import { render, staticRenderFns } from "./ContentTable.vue?vue&type=template&id=cdd078cc&scoped=true"
import script from "./ContentTable.vue?vue&type=script&lang=js"
export * from "./ContentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd078cc",
  null
  
)

export default component.exports